/* assets/quick-view.js
   Quick View modal
   - Farbe (Color) => swatches (supports theme color map via window.QV_SWATCH_MAP_TEXT)
   - Menge (Size/Qty) => buttons
   - Other options => dropdown
   - Thumbnail images under main image
   - Stock text below options (from data-qv-stock-text or window.QV_STOCK_TEXT)
   - Add to cart => Adding… -> ✓ Added -> reset, reloadCart/openCartDrawer, close popup
*/

(function () {
  const modal = document.getElementById("QuickViewModal");
  if (!modal) return;

  const body = modal.querySelector("[data-qv-body]");
  if (!body) return;

  // store stock text from clicked open button
  let currentStockText = "";

  function openModal() {
    modal.classList.add("is-open");
    modal.setAttribute("aria-hidden", "false");
    document.documentElement.classList.add("qv-lock");
  }

  function closeModal() {
    modal.classList.remove("is-open");
    modal.setAttribute("aria-hidden", "true");
    document.documentElement.classList.remove("qv-lock");
    body.innerHTML = "";
    currentStockText = "";
  }

  modal.addEventListener("click", (e) => {
    if (e.target.closest("[data-qv-close]")) closeModal();
  });

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && modal.classList.contains("is-open")) closeModal();
  });

  function money(cents) {
    const format =
      (window.theme && window.theme.moneyFormat) ||
      (window.Shopify && window.Shopify.money_format) ||
      "{{amount}}";

    const value = Number(cents || 0);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ",";
      decimal = decimal || ".";

      const n = (number / 100).toFixed(precision);
      const parts = n.split(".");
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.join(decimal);
    }

    // Handle Shopify format tokens
    const tokenMatch = format.match(/\{\{\s*(amount|amount_no_decimals|amount_with_comma_separator|amount_no_decimals_with_comma_separator|amount_with_space_separator|amount_no_decimals_with_space_separator|amount_with_apostrophe_separator|amount_no_decimals_with_apostrophe_separator)\s*\}\}/);

    const token = tokenMatch ? tokenMatch[1] : "amount";

    let formatted = "";
    switch (token) {
      case "amount":
        formatted = formatWithDelimiters(value, 2, ",", ".");
        break;
      case "amount_no_decimals":
        formatted = formatWithDelimiters(value, 0, ",", ".");
        break;
      case "amount_with_comma_separator":
        formatted = formatWithDelimiters(value, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        formatted = formatWithDelimiters(value, 0, ".", ",");
        break;
      case "amount_with_space_separator":
        formatted = formatWithDelimiters(value, 2, " ", ".");
        break;
      case "amount_no_decimals_with_space_separator":
        formatted = formatWithDelimiters(value, 0, " ", ".");
        break;
      case "amount_with_apostrophe_separator":
        formatted = formatWithDelimiters(value, 2, "'", ".");
        break;
      case "amount_no_decimals_with_apostrophe_separator":
        formatted = formatWithDelimiters(value, 0, "'", ".");
        break;
      default:
        formatted = formatWithDelimiters(value, 2, ",", ".");
    }

    return format.replace(tokenMatch ? tokenMatch[0] : "{{amount}}", formatted);
  }



  function escapeHtml(str) {
    return String(str || "").replace(/[&<>"']/g, (m) => ({
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
    }[m]));
  }

  function normalizeImg(url) {
    if (!url) return "";
    let u = String(url).split("?")[0];
    u = u.replace(/^https?:\/\//, "");
    u = u.replace(/_(\d+x\d+|\d+x)\.(jpg|jpeg|png|webp|gif)$/i, ".$2");
    return u.toLowerCase();
  }

  // ---------- Swatch color map (optional) ----------
  // theme.liquid (optional):
  // <script>window.QV_SWATCH_MAP_TEXT = {{ settings.qv_swatch_colors | json }};</script>
  function parseSwatchMap(text) {
    const map = {};
    if (!text) return map;

    String(text)
      .split(/\r?\n/)
      .forEach((line) => {
        const clean = line.trim();
        if (!clean || clean.indexOf(":") === -1) return;
        const parts = clean.split(":");
        const key = (parts[0] || "").trim().toLowerCase();
        const value = (parts.slice(1).join(":") || "").trim();
        if (key && value) map[key] = value;
      });

    return map;
  }

  const QV_SWATCH_MAP = parseSwatchMap(window.QV_SWATCH_MAP_TEXT || "");
  function getSwatchColor(value) {
    const key = String(value || "").trim().toLowerCase();
    return QV_SWATCH_MAP[key] || value;
  }
  // ---------------------------------------------

  function getOptionName(opt, idx) {
    if (typeof opt === "string") return opt;
    if (opt && typeof opt.name === "string") return opt.name;
    return `Option ${idx + 1}`;
  }

  function getOptionValues(p, opt, idx) {
    if (opt && Array.isArray(opt.values) && opt.values.length) return opt.values;
    return [
      ...new Set(
        (p.variants || [])
          .map((v) => (v.options && v.options[idx] ? v.options[idx] : null))
          .filter(Boolean)
      ),
    ];
  }

  function isColorOption(name) {
    return /colou?r/i.test(name) || /farbe/i.test(name);
  }

  function isSizeOption(name) {
    return /menge/i.test(name) || /size/i.test(name) || /gr(ö|oe)ße/i.test(name) || /groesse/i.test(name);
  }

  function render(p, stockText) {
    const variants = p.variants || [];
    const v0 = variants.find((v) => v.available) || variants[0];

    const images = Array.isArray(p.images) ? p.images : [];
    const mainImg =
      (v0 && v0.featured_image && v0.featured_image.src) ||
      p.featured_image ||
      images[0] ||
      "";

    const opts = Array.isArray(p.options) ? p.options : [];

    const optionsHtml = opts
      .map((opt, idx) => {
        const optName = getOptionName(opt, idx);
        const values = getOptionValues(p, opt, idx);

        const color = isColorOption(optName);
        const size = isSizeOption(optName);

        if (color) {
          return `
            <div class="qv__opt" data-qv-opt-wrap="${idx}">
              <label class="qv__label">${escapeHtml(optName)}</label>

              <div class="qv__swatches" role="radiogroup" aria-label="${escapeHtml(optName)}" data-qv-swatch-group="${idx}">
                ${values.map((val) => {
                  const checked = (v0 && v0.options && v0.options[idx] === val) ? "checked" : "";
                  const selectedClass = checked ? "is-selected" : "";
                  const bg = getSwatchColor(val);
                  return `
                    <label class="qv__swatch ${selectedClass}" title="${escapeHtml(val)}">
                      <input type="radio" name="qv-opt-${idx}" value="${escapeHtml(val)}" data-qv-option="${idx}" ${checked}>
                      <span style="background:${escapeHtml(bg)};"></span>
                    </label>
                  `;
                }).join("")}
              </div>

              <div class="qv__swatch-name" data-qv-selected-label="${idx}">
                ${escapeHtml((v0 && v0.options && v0.options[idx]) || "")}
              </div>
            </div>
          `;
        }

        if (size) {
          return `
            <div class="qv__opt" data-qv-opt-wrap="${idx}">
              <label class="qv__label">${escapeHtml(optName)}</label>

              <div class="qv__size" role="radiogroup" aria-label="${escapeHtml(optName)}" data-qv-size-group="${idx}">
                ${values.map((val) => {
                  const checked = (v0 && v0.options && v0.options[idx] === val) ? "checked" : "";
                  const selectedClass = checked ? "is-selected" : "";
                  return `
                    <label class="qv__size-btn ${selectedClass}">
                      <input type="radio" name="qv-opt-${idx}" value="${escapeHtml(val)}" data-qv-option="${idx}" ${checked}>
                      <span>${escapeHtml(val)}</span>
                    </label>
                  `;
                }).join("")}
              </div>
            </div>
          `;
        }

        return `
          <div class="qv__opt">
            <label class="qv__label">${escapeHtml(optName)}</label>
            <select class="qv__select" data-qv-option="${idx}">
              ${values.map((val) => `
                <option value="${escapeHtml(val)}" ${(v0 && v0.options && v0.options[idx] === val) ? "selected" : ""}>
                  ${escapeHtml(val)}
                </option>
              `).join("")}
            </select>
          </div>
        `;
      })
      .join("");

    const hasCompare =
      v0 && v0.compare_at_price && Number(v0.compare_at_price) > Number(v0.price);

    const thumbsHtml = images.length
      ? `
        <div class="qv__thumbs" data-qv-thumbs>
          ${images.map((src, i) => {
            const active = normalizeImg(src) === normalizeImg(mainImg) ? "is-active" : "";
            return `
              <button type="button" class="qv__thumb ${active}" data-qv-thumb data-qv-thumb-src="${escapeHtml(src)}" aria-label="Image ${i + 1}">
                <img src="${escapeHtml(src)}" alt="">
              </button>
            `;
          }).join("")}
        </div>
      `
      : "";

    // stock text only if available
    const st = (stockText || "").trim();
    const stockHtml =
      p.available && st
        ? `<div class="stock-text-block"><div class="stock-text">${escapeHtml(st)}</div></div>`
        : "";

    return `
      <div class="qv__grid">
        <div class="qv__media">
          ${mainImg ? `<img class="qv__img" data-qv-main-img src="${escapeHtml(mainImg)}" alt="${escapeHtml(p.title)}">` : ""}
          ${thumbsHtml}
        </div>

        <div class="qv__info">
          <h3 class="qv__title">${escapeHtml(p.title)}</h3>

          <div class="qv__prices">
            ${hasCompare ? `<span class="qv__compare" data-qv-compare>${money(v0.compare_at_price)}</span>` : ""}
            <span class="qv__price" data-qv-price>${money(v0 ? v0.price : 0)}</span>
          </div>

          <div class="qv__options">${optionsHtml}</div>

          <!-- ✅ stock text below variant/options -->
          ${stockHtml}

          <div class="qv__actions">
            <div class="qv__qty">
              <button type="button" data-qv-qty="dec">−</button>
              <input type="number" min="1" value="1" data-qv-qty-input>
              <button type="button" data-qv-qty="inc">+</button>
            </div>

            <button class="qv__atc" data-qv-atc ${v0 && v0.available ? "" : "disabled"}>
              ${v0 && v0.available ? "In den Warenkorb" : "Ausverkauft"}
            </button>
          </div>
        </div>
      </div>

      ${/* ✅ YOUR FULL BENEFITS HTML */""}
      <div class="qv__benefits">
        <div class="qv__benefit">
          <span class="qv__benefit-icon" aria-hidden="true">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M21.5 14.2834V7.28292C21.5 7.10808 21.4083 6.94604 21.2583 6.85609C21.0995 6.7608 20.9009 6.76157 20.7429 6.85808L14.0012 10.974C13.0927 11.5287 12.6384 11.8061 12.1525 11.9144C11.7228 12.0101 11.2772 12.0101 10.8475 11.9144C10.3616 11.8061 9.9073 11.5287 8.99878 10.974L2.25714 6.85808C2.09906 6.76157 1.90048 6.7608 1.74166 6.85609C1.59174 6.94604 1.5 7.10808 1.5 7.28292V14.2834C1.5 15.2744 1.5 15.7699 1.64219 16.2152C1.76802 16.6092 1.97396 16.9729 2.24708 17.2835C2.55572 17.6345 2.98062 17.8895 3.83042 18.3993L9.03042 21.5193C9.9283 22.0581 10.3773 22.3275 10.8565 22.4327C11.2805 22.5258 11.7195 22.5258 12.1435 22.4327C12.6227 22.3275 13.0717 22.0581 13.9696 21.5193L19.1696 18.3993C20.0194 17.8895 20.4443 17.6345 20.7529 17.2835C21.026 16.9729 21.232 16.6092 21.3578 16.2152C21.5 15.7699 21.5 15.2744 21.5 14.2834Z" fill="#171717" fill-opacity="0.1"/>
              <path d="M6.99988 9.49947L16 3.99947M11.5 12.4995L20.5 6.99947M11.5 12.4995L2.5 6.99947M11.5 12.4995V22.4995M1.5 9.71718V14.2818C1.5 15.2728 1.5 15.7683 1.64219 16.2136C1.76802 16.6076 1.97396 16.9713 2.24708 17.2819C2.55572 17.6329 2.98062 17.8879 3.83042 18.3978L9.03042 21.5178C9.9283 22.0565 10.3773 22.3259 10.8565 22.4311C11.2805 22.5242 11.7195 22.5242 12.1435 22.4311C12.6227 22.3259 13.0717 22.0565 13.9696 21.5178L19.1696 18.3978C20.0194 17.8879 20.4443 17.6329 20.7529 17.2819C21.026 16.9713 21.232 16.6076 21.3578 16.2136C21.5 15.7683 21.5 15.2728 21.5 14.2818V9.71718C21.5 8.72616 21.5 8.23064 21.3578 7.7854C21.232 7.39139 21.026 7.02765 20.7529 6.71704C20.4443 6.36604 20.0194 6.1111 19.1696 5.60122L13.9696 2.48122C13.0717 1.94248 12.6227 1.67311 12.1435 1.56786C11.7195 1.47477 11.2805 1.47477 10.8565 1.56786C10.3773 1.67311 9.9283 1.94248 9.03042 2.48122L3.83042 5.60122C2.98062 6.1111 2.55572 6.36604 2.24708 6.71704C1.97396 7.02765 1.76802 7.39139 1.64219 7.7854C1.5 8.23064 1.5 8.72616 1.5 9.71718Z" stroke="#171717" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </span>
          <span>Kostenloser Versand</span>
        </div>

        <div class="qv__benefit">
          <span class="qv__benefit-icon" aria-hidden="true">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M21.2506 13.5004C21.2489 15.0912 20.6162 16.6163 19.4913 17.7411C18.3665 18.866 16.8414 19.4987 15.2506 19.5004H7.00059C6.80168 19.5004 6.61091 19.4214 6.47026 19.2807C6.32961 19.1401 6.25059 18.9493 6.25059 18.7504C6.25059 18.5515 6.32961 18.3607 6.47026 18.2201C6.61091 18.0794 6.80168 18.0004 7.00059 18.0004H15.2506C16.4441 18.0004 17.5887 17.5263 18.4326 16.6824C19.2765 15.8385 19.7506 14.6939 19.7506 13.5004C19.7506 12.3069 19.2765 11.1624 18.4326 10.3184C17.5887 9.47452 16.4441 9.00042 15.2506 9.00042H4.3109L7.53122 12.2198C7.67195 12.3605 7.75101 12.5514 7.75101 12.7504C7.75101 12.9494 7.67195 13.1403 7.53122 13.281C7.39048 13.4218 7.19961 13.5008 7.00059 13.5008C6.80157 13.5008 6.6107 13.4218 6.46996 13.281L1.96996 8.78104C1.90023 8.71139 1.84491 8.62867 1.80717 8.53762C1.76943 8.44657 1.75 8.34898 1.75 8.25042C1.75 8.15186 1.76943 8.05426 1.80717 7.96321C1.84491 7.87216 1.90023 7.78945 1.96996 7.71979L6.46996 3.21979C6.6107 3.07906 6.80157 3 7.00059 3C7.19961 3 7.39048 3.07906 7.53121 3.21979C7.67195 3.36052 7.75101 3.55139 7.75101 3.75042C7.75101 3.94944 7.67195 4.14031 7.53122 4.28104L4.3109 7.50042H15.2506C16.8414 7.50215 18.3665 8.13485 19.4913 9.2597C20.6162 10.3845 21.2489 11.9097 21.2506 13.5004Z" fill="black"/>
            </svg>
          </span>
          <span>30 Tage Geld-Zurück-Garantie</span>
        </div>

        <div class="qv__benefit">
          <span class="qv__benefit-icon" aria-hidden="true">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M5.59 17.4293H4.25C3.15 17.4293 2.25 16.5393 2.25 15.4293V12.2793C2.25 11.1793 3.14 10.2793 4.25 10.2793H5.59C6.69 10.2793 7.59 11.1693 7.59 12.2793V15.4293C7.59 16.5293 6.7 17.4293 5.59 17.4293ZM20.06 15.4293V12.2793C20.06 11.1793 19.17 10.2793 18.06 10.2793H16.72C15.62 10.2793 14.72 11.1693 14.72 12.2793V15.4293C14.72 16.5293 15.61 17.4293 16.72 17.4293H18.06C19.16 17.4293 20.06 16.5393 20.06 15.4293Z" fill="#171717" fill-opacity="0.1"/>
              <path d="M4.44 17.43V19.86C4.44 20.93 5.51 22 6.93 22H11.15M20.06 13.78V10.67C20.07 5.74 16.08 1.75 11.16 1.75C6.24 1.75 2.25 5.74 2.25 10.66V13.77M11.77 21.99C11.77 22.32 11.5 22.59 11.17 22.59C10.84 22.59 10.57 22.32 10.57 21.99M11.77 21.99C11.77 21.66 11.5 21.39 11.17 21.39C10.84 21.39 10.57 21.66 10.57 21.99M11.77 21.99H10.57M20.07 14.76V12.96C20.07 12.13 20.07 11.71 19.93 11.39C19.75 10.95 19.4 10.61 18.97 10.43C18.64 10.29 18.23 10.29 17.4 10.29C16.57 10.29 16.15 10.29 15.83 10.43C15.39 10.61 15.05 10.96 14.87 11.39C14.73 11.72 14.73 12.13 14.73 12.96V14.76C14.73 15.59 14.73 16.01 14.87 16.33C15.05 16.77 15.4 17.11 15.83 17.29C16.16 17.43 16.57 17.43 17.4 17.43C18.23 17.43 18.65 17.43 18.97 17.29C19.41 17.11 19.75 16.76 19.93 16.33C20.07 16 20.07 15.59 20.07 14.76ZM4.93 17.43C5.76 17.43 6.18 17.43 6.5 17.29C6.94 17.11 7.28 16.76 7.46 16.33C7.6 16 7.6 15.59 7.6 14.76V12.96C7.6 12.13 7.6 11.71 7.46 11.39C7.28 10.95 6.93 10.61 6.5 10.43C6.17 10.29 5.76 10.29 4.93 10.29C4.1 10.29 3.68 10.29 3.36 10.43C2.92 10.61 2.58 10.96 2.4 11.39C2.26 11.72 2.26 12.13 2.26 12.96V14.76C2.26 15.59 2.26 16.01 2.4 16.33C2.58 16.77 2.93 17.11 3.36 17.29C3.69 17.43 4.1 17.43 4.93 17.43Z" stroke="#171717" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </span>
          <span>Deutscher Kundensupport</span>
        </div>

        <div class="qv__benefit">
          <span class="qv__benefit-icon" aria-hidden="true">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M3 8.11906C3 6.98995 3 6.42539 3.17756 5.93251C3.33451 5.49684 3.59019 5.10341 3.92457 4.78305C4.30286 4.42061 4.81875 4.19133 5.85055 3.73276L9.40073 2.15491C10.3579 1.7295 10.8365 1.5168 11.334 1.43279C11.7749 1.35834 12.2251 1.35834 12.666 1.43279C13.1635 1.5168 13.6421 1.7295 14.5993 2.15491L18.1495 3.73276C19.1812 4.19133 19.6971 4.42061 20.0754 4.78305C20.4098 5.10341 20.6655 5.49684 20.8224 5.93251C21 6.42539 21 6.98995 21 8.11906V13.5745C21 14.8268 21 15.4529 20.8274 16.0213C20.6746 16.5244 20.4241 16.9925 20.0902 17.3988C19.713 17.8577 19.192 18.205 18.1501 18.8996L14.6626 21.2246C13.7003 21.8662 13.2192 22.1869 12.6991 22.3115C12.2395 22.4217 11.7605 22.4217 11.3009 22.3115C10.7808 22.1869 10.2997 21.8662 9.33744 21.2246L5.84992 18.8996C4.80796 18.205 4.28697 17.8577 3.90982 17.3988C3.57592 16.9925 3.32541 16.5244 3.1726 16.0213C3 15.4529 3 14.8268 3 13.5745V8.11906Z" fill="#171717" fill-opacity="0.1"/>
              <path d="M9 11.9997L11 13.9997L15.5 9.49968M9.40073 2.15491L5.85055 3.73276C4.81875 4.19133 4.30286 4.42061 3.92457 4.78305C3.59019 5.10341 3.33451 5.49684 3.17756 5.93251C3 6.42539 3 6.98995 3 8.11906V13.5745C3 14.8268 3 15.4529 3.1726 16.0213C3.32541 16.5244 3.57592 16.9925 3.90982 17.3988C4.28697 17.8577 4.80796 18.205 5.84992 18.8996L9.33744 21.2246C10.2997 21.8662 10.7808 22.1869 11.3009 22.3115C11.7605 22.4217 12.2395 22.4217 12.6991 22.3115C13.2192 22.1869 13.7003 21.8662 14.6626 21.2246L18.1501 18.8996C19.192 18.205 19.713 17.8577 20.0902 17.3988C20.4241 16.9925 20.6746 16.5244 20.8274 16.0213C21 15.4529 21 14.8268 21 13.5745V8.11906C21 6.98995 21 6.42539 20.8224 5.93251C20.6655 5.49684 20.4098 5.10341 20.0754 4.78305C19.6971 4.42061 19.1812 4.19133 18.1495 3.73276L14.5993 2.15491C13.6421 1.7295 13.1635 1.5168 12.666 1.43279C12.2251 1.35834 11.7749 1.35834 11.334 1.43279C10.8365 1.5168 10.3579 1.7295 9.40073 2.15491Z" stroke="#171717" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </span>
          <span>12 Monate Garantie</span>
        </div>
      </div>
    `;
  }

  function init(scope, p) {
    const priceEl = scope.querySelector("[data-qv-price]");
    let compareEl = scope.querySelector("[data-qv-compare]");
    const atcBtn = scope.querySelector("[data-qv-atc]");
    const qtyInput = scope.querySelector("[data-qv-qty-input]");
    const qtyWrap = scope.querySelector(".qv__qty");
    const mainImgEl = scope.querySelector("[data-qv-main-img]");
    const thumbsWrap = scope.querySelector("[data-qv-thumbs]");
    const optsCount = Array.isArray(p.options) ? p.options.length : 0;

    function setMainImage(src) {
      if (!mainImgEl || !src) return;
      mainImgEl.src = src;

      if (!thumbsWrap) return;
      const n = normalizeImg(src);
      thumbsWrap.querySelectorAll("[data-qv-thumb]").forEach((btn) => {
        const s = btn.getAttribute("data-qv-thumb-src") || "";
        btn.classList.toggle("is-active", normalizeImg(s) === n);
      });
    }

    function getSelectedOptions() {
      const selected = [];
      for (let i = 0; i < optsCount; i++) {
        const sel = scope.querySelector(`select[data-qv-option="${i}"]`);
        if (sel) {
          selected.push(sel.value);
          continue;
        }
        const checked = scope.querySelector(`input[type="radio"][data-qv-option="${i}"]:checked`);
        selected.push(checked ? checked.value : "");
      }
      return selected;
    }

    function currentVariant() {
      const selected = getSelectedOptions();
      return (p.variants || []).find(
        (v) => v.options && v.options.every((opt, i) => opt === selected[i])
      );
    }

    function updateUI() {
      const v = currentVariant();
      if (!v) return;

      if (priceEl) priceEl.innerHTML = money(v.price);

      if (v.compare_at_price && Number(v.compare_at_price) > Number(v.price)) {
        if (!compareEl && priceEl) {
          priceEl.insertAdjacentHTML(
            "beforebegin",
            `<span class="qv__compare" data-qv-compare>${money(v.compare_at_price)}</span>`
          );
          compareEl = scope.querySelector("[data-qv-compare]");
        } else if (compareEl) {
          compareEl.innerHTML = money(v.compare_at_price);
        }
      } else if (compareEl) {
        compareEl.remove();
        compareEl = null;
      }

      if (atcBtn) {
        atcBtn.disabled = !v.available;
        atcBtn.textContent = v.available ? "In den Warenkorb" : "Ausverkauft";
        atcBtn.dataset.variantId = v.id;
      }

      if (v.featured_image && v.featured_image.src) {
        setMainImage(v.featured_image.src);
      }
    }

    if (thumbsWrap) {
      thumbsWrap.addEventListener("click", (e) => {
        const btn = e.target.closest("[data-qv-thumb]");
        if (!btn) return;
        const src = btn.getAttribute("data-qv-thumb-src");
        if (src) setMainImage(src);
      });
    }

    scope.querySelectorAll("select[data-qv-option]").forEach((s) => {
      s.addEventListener("change", updateUI);
    });

    scope.addEventListener("change", (e) => {
      const radio = e.target.closest('input[type="radio"][data-qv-option]');
      if (!radio) return;

      const idx = Number(radio.getAttribute("data-qv-option"));

      const swatchGroup = scope.querySelector(`[data-qv-swatch-group="${idx}"]`);
      if (swatchGroup) {
        swatchGroup.querySelectorAll(".qv__swatch").forEach((l) => l.classList.remove("is-selected"));
        radio.closest(".qv__swatch")?.classList.add("is-selected");

        const label = scope.querySelector(`[data-qv-selected-label="${idx}"]`);
        if (label) label.textContent = radio.value;
      }

      const sizeGroup = scope.querySelector(`[data-qv-size-group="${idx}"]`);
      if (sizeGroup) {
        sizeGroup.querySelectorAll(".qv__size-btn").forEach((l) => l.classList.remove("is-selected"));
        radio.closest(".qv__size-btn")?.classList.add("is-selected");
      }

      updateUI();
    });

    if (qtyWrap && qtyInput) {
      qtyWrap.addEventListener("click", (e) => {
        const b = e.target.closest("[data-qv-qty]");
        if (!b) return;
        const dir = b.getAttribute("data-qv-qty");
        const cur = parseInt(qtyInput.value || "1", 10);
        qtyInput.value = Math.max(1, cur + (dir === "inc" ? 1 : -1));
      });
    }

    if (atcBtn) {
      atcBtn.addEventListener("click", async () => {
        const v = currentVariant();
        if (!v || !v.available) return;

        const originalText = "In den Warenkorb";
        atcBtn.disabled = true;
        atcBtn.textContent = "Wird hinzugefügt …";
        atcBtn.classList.add("qv-adding");

        try {
          const res = await fetch("/cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json", Accept: "application/json" },
            body: JSON.stringify({
              id: Number(v.id),
              quantity: Number((qtyInput && qtyInput.value) || 1),
            }),
          });

          if (!res.ok) throw new Error("Add to cart failed");
          await res.json();

          if (typeof reloadCart === "function") {
            reloadCart(() => {
              // if (typeof openCartDrawer === "function") openCartDrawer();
            });
          } else if (typeof openCartDrawer === "function") {
            // openCartDrawer();
          }

          atcBtn.textContent = "✓ Im Warenkorb";
          atcBtn.classList.remove("qv-adding");
          atcBtn.classList.add("qv-added");

          setTimeout(() => closeModal(), 450);

          setTimeout(() => {
            atcBtn.textContent = originalText;
            atcBtn.classList.remove("qv-added");
            atcBtn.disabled = false;
          }, 1200);
        } catch (err) {
          console.error(err);
          atcBtn.textContent = "TRY AGAIN";

          setTimeout(() => {
            const vv = currentVariant();
            atcBtn.textContent = vv && vv.available ? originalText : "Ausverkauft";
            atcBtn.classList.remove("qv-adding");
            atcBtn.disabled = !(vv && vv.available);
          }, 1200);
        }
      });
    }

    updateUI();
  }

  function bindQuickViewButtons(root = document) {
    root.querySelectorAll("[data-quickview-open]").forEach((btn) => {
      if (btn.dataset.qvBound === "1") return;
      btn.dataset.qvBound = "1";

      btn.addEventListener("click", async (e) => {
        e.preventDefault();

        const handle = btn.getAttribute("data-product-handle");
        if (!handle) return;

        // stock text (button > global fallback)
        currentStockText =
          (btn.getAttribute("data-qv-stock-text") || "").trim() ||
          (window.QV_STOCK_TEXT || "").trim();

        openModal();
        body.innerHTML = `<div class="qv__loader">Einen Moment bitte…</div>`;

        try {
          const res = await fetch(`/products/${handle}.js`);
          if (!res.ok) throw new Error("Product fetch failed");

          const product = await res.json();
          body.innerHTML = render(product, currentStockText);
          init(body, product);
        } catch (err) {
          console.error(err);
          body.innerHTML = `<div class="qv__error">Sorry, could not load product.</div>`;
        }
      });
    });
  }

  document.addEventListener("DOMContentLoaded", () => {
    bindQuickViewButtons();
  });
})();
